<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"/>

    <!-- 작업자 정보 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 작업자 정보</h5>
        </vs-col>
      </vs-row>

      <div class="grid grid-cols-2 gap-y-4 gap-x-8">
        <!-- 작업자정보 (입력) -->
        <input-form label="작업자 검색">
          <member-selector
            popup-type="user"
            v-model="form.작업자정보.작업자.id"
            :member-name="form.작업자정보.작업자.name"
            :readonly="board.readonly"
            flex
            @select="(member) => onSelectMember(form.작업자정보.작업자, member)"
          />
        </input-form>
        <div></div>
        <input-form class="col-span-2" label="제한 사업장">
          <div class="flex flex-wrap gap-4">
            <vs-checkbox
              v-for="site in 제한사업장옵션"
              :key="site"
              color="secondary"
              v-model="form.제한사업장"
              :vs-value="site"
            >{{ site }}</vs-checkbox>
          </div>
        </input-form>
        <input-form label="출입제한 기한">
          <date-selector-rang class="w-full" flex v-model="form.출입제한기간" />
        </input-form>
        <input-form label="출입제한 사유">
          <ml-input class="w-full" v-model="form.출입제한사유" />
        </input-form>
        <input-form class="col-span-2" label="회원구분">
          <radio-group
            v-model="form.작업자정보.회원구분"
            flex
            readonly
            :items="[
              { label: '사내 수급업체 안전 관련 문서 작성 담당자', value: '사내_수급업체_문서_담당자' },
              { label: '사외 수급업체 안전 관련 문서 작성 담당자', value: '사외_수급업체_문서_담당자' },
              { label: '수급업체 일반직원', value: '수급업체_일반직원' },
              { label: '일용직', value: '일용직' },
            ]"/>
        </input-form>

        <!-- 작업자정보 (읽기전용) -->
        <input-form label="작업자 사업장명">
          <div class="print-input">{{ form.작업자정보.작업자.field.field_name }}</div>
        </input-form>
        <input-form label="">
          <div class="print-input">{{ form.작업자정보.작업자.담당부서 }}</div>
        </input-form>

        <input-form label="업체명(사업자등록번호)">
          <div class="grid grid-cols-2 gap-y-4 gap-x-2">
            <div class="print-input">{{ form.작업자정보.작업자.company.com_name }}</div>
            <div class="print-input">{{ form.작업자정보.작업자.company.com_number }}</div>
          </div>
        </input-form>
        <div></div>
        <input-form label="아이디">
          <div class="print-input">{{ form.작업자정보.작업자.username }}</div>
        </input-form>
        <input-form class="grid-item gap-2" label="내국인/외국인">
          <radio-group
            class="col-span-4 my-2"
            flex
            :items="[
                { label: '내국인', value: false },
                { label: '외국인', value: true },
              ]"
            :row-count="2"
            v-model="form.작업자정보.작업자.isForeigner"
            readonly
          />
        </input-form>
        <input-form label="이름">
          <div class="print-input">{{ form.작업자정보.작업자.name }}</div>
        </input-form>
        <input-form class="grid-item" :label="form.작업자정보.작업자.isForeigner ? '외국인등록번호(앞 7자리 한정)' : '주민등록번호(앞 7자리 한정)'">
          <ml-input class="w-full" :value="formatRRN" readonly />
        </input-form>
        <input-form label="휴대폰번호">
          <div class="print-input">{{ formatPhone(form.작업자정보.작업자.phone) }}</div>
        </input-form>
        <input-form label="이메일">
          <div class="print-input">{{ form.작업자정보.작업자.email }}</div>
        </input-form>
        <input-form label="직책">
          <div class="print-input">{{ form.작업자정보.작업자.rank }}</div>
        </input-form>
        <input-form label="직종">
          <div class="print-input">{{ form.작업자정보.작업자.department }}</div>
        </input-form>
      </div>
    </div>
  </div>
</template>

<script>
import { formatPhone } from "@/util/DataUtil";
import InputForm from "@/views/pages/register/InputForm.vue";
import MemberSelector from "@/components/selector/MemberSelector.vue";
import FieldSelectModule from "@/views/modules/FieldSelectModule.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import HttpRequest from "@/util/HttpRequest";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";

export default {
  components: {
    DateSelectorRang,
    RadioGroup,
    FieldSelectModule,
    MemberSelector,
    InputForm,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      제한사업장옵션: ["전사", "본사", "인천공장", "당진공장", "포항공장", "중앙기술연구소"],
      form: {
        stdInfo: {},
        "출입제한기간": { "sDate": "", "eDate": "" },
        "출입제한사유": "",
        "제한사업장": [],
        "작업자정보": {
          "작업자": {
            "id": 0,
            "name": "",
            "field": { "id": 0, "field_name": "" },
            "담당부서": "",
            "company": {
              "id": 0,
              "com_name": "", // 업체명
              "com_number": "", // 사업자등록번호
            },
            "username": "", // 아이디
            "phone": "", // 휴대폰번호
            "email": "", // 이메일
            "rank": "", // 직책
            "department": "", // 직종
            "isForeigner": null, // 내국인 / 외국인
            "rrn": "", // 주민등록번호
          },
          "회원구분": null,
        },
      },
    };
  },
  computed: {
    formatRRN: {
      get() {
        const rrn = this.form.작업자정보.작업자.rrn;
        if (!rrn || rrn.length !== 7 || isNaN(rrn)) {
          return "";
        }

        const datePart = rrn.slice(0, 6);
        const lastDigit = rrn[6];

        return `${datePart}-${lastDigit}******`;
      },
      set(newValue) {
        const cleanValue = newValue.replace(/[^0-9]/g, "").slice(0, 7);
        this.form.작업자정보.작업자.rrn = cleanValue;
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    formatPhone,
    async onSelectMember(member, selectedMember) {
      member.id = selectedMember.id;
      const response = await HttpRequest.get(`/api/v1/member/${member.id}/detail`);
      const meta = this.fixMissingMetaData(response.metas);

      member.name = selectedMember.name;
      member.company = selectedMember.company || { id: 0, com_name: "", com_number: "" };
      member.username = selectedMember.username;
      member.phone = selectedMember.phone;
      member.email = selectedMember.email;
      member.rank = selectedMember.rank;
      member.department = selectedMember.department;

      // meta 정보
      member.담당부서 = meta.담당부서;
      member.field = meta.field;
      member.rrn = meta.rrn;
      member.isForeigner = meta.isForeigner || false;
    },
    fixMissingMetaData(metas) {
      const metaKeys = {
        // 회원구분
        registerType: "registerType",
        // 사업장
        field_id: "field.id",
        field_name: "field.field_name",
        // 담당부서
        담당부서: "담당부서",
        // 업체
        com_name: "업체.com_name",
        com_number: "업체.com_number",
        // 내국인/외국인
        foreign: "is_foreigner",
        // 주민등록번호앞
        rrn: "rrn",
        // 직종
        직종: "직종",
        // 건설업기초안전교육
        건설업기초안전교육_id: "건설업기초안전교육.id",
        건설업기초안전교육_fileName: "건설업기초안전교육.fileName",
        건설업기초안전교육_fileSize: "건설업기초안전교육.fileSize",
        건설업기초안전교육_path: "건설업기초안전교육.path",
        건설업기초안전교육_thumb: "건설업기초안전교육.thumb",
        // 교육이수번호
        교육이수번호: "교육이수번호",
        // 신분증
        신분증: "신분증사진",
        // 장비운전자
        장비운전자: "장비운전자",
        // 건설기계조종사면허
        건설기계조종사면허번호: "건설기계조종사면허번호",
        건설기계조종사면허증: "건설기계조종사면허증사진",
      };

      const metaValues = Object.keys(metaKeys).reduce((acc, key) => {
        const meta = metas.find((meta) => meta.meta_key === metaKeys[key]);
        acc[key] = meta ? meta.meta_value : "";
        return acc;
      }, {});

      const registerType = metaValues.registerType;
      const field_id = metaValues.field_id;
      const field_name = metaValues.field_name;
      const 담당부서 = metaValues.담당부서;
      const foreignValue = !!(metaValues.foreign && metaValues.foreign === 1);
      const rrn = metaValues.rrn;
      const 직종 = metaValues.직종;
      const 건설업기초안전교육_id = metaValues.건설업기초안전교육_id;
      const 건설업기초안전교육_fileName = metaValues.건설업기초안전교육_fileName;
      const 건설업기초안전교육_fileSize = metaValues.건설업기초안전교육_fileSize;
      const 건설업기초안전교육_path = metaValues.건설업기초안전교육_path;
      const 건설업기초안전교육_thumb = metaValues.건설업기초안전교육_thumb;
      const 교육이수번호 = metaValues.교육이수번호;
      const 신분증 = metaValues.신분증;
      const 장비운전자 = metaValues.장비운전자;
      const 건설기계조종사면허번호 = metaValues.건설기계조종사면허번호;
      const 건설기계조종사면허증 = metaValues.건설기계조종사면허증;

      return {
        registerType,
        field: {
          id: isNaN(Number(field_id)) ? 0 : Number(field_id),
          field_name: field_name,
        },
        담당부서,
        isForeigner: foreignValue,
        rrn,
        직종,
        건설업기초안전교육: {
          id: 건설업기초안전교육_id,
          fileName: 건설업기초안전교육_fileName,
          fileSize: 건설업기초안전교육_fileSize,
          path: 건설업기초안전교육_path,
          thumb: 건설업기초안전교육_thumb,
        },
        교육이수번호,
        장비운전자: 장비운전자 === "0" ? false : true,
        건설기계조종사면허번호,
        enc: {
          신분증사진: 신분증,
          건설기계조종사면허증사진: 건설기계조종사면허증
        },
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.print-input {
  background-color: #f5f5f5;
}
</style>
